/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
import { Interval, MAX_DATE_INTERVAL } from "~/constants";

const getDateInterval: (interval: Interval, pickedForMax?: string) => { from: string; to: string } = (
  interval,
  pickedForMax = "",
) => {
  const dateFrom = new Date(Date.now());
  const dateTo = new Date(Date.now());
  const picked = new Date(pickedForMax);
  //"Compare change with the same ratio (prev period days and actual period days)"
  const daysInCurrentPeriod = dateFrom.getUTCDate() - (dateFrom.getUTCDate() - dateFrom.getUTCDay());

  switch (interval) {
    case Interval.TODAY:
      dateFrom.setUTCDate(dateFrom.getUTCDate());
      dateTo.setUTCDate(dateTo.getUTCDate());
      break;
    case Interval.YESTERDAY:
      dateFrom.setUTCDate(dateFrom.getUTCDate() - 1);
      dateTo.setUTCDate(dateTo.getUTCDate() - 1);
      break;
    case Interval.LAST_7_DAYS:
      dateFrom.setUTCDate(dateFrom.getUTCDate() - 7);
      dateTo.setUTCDate(dateTo.getUTCDate() - 1);
      break;
    case Interval.LAST_WEEK:
      dateFrom.setUTCDate(dateFrom.getUTCDate() - dateFrom.getUTCDay() - 6);
      dateTo.setUTCDate(dateTo.getUTCDate() - dateTo.getUTCDay());
      break;
    case Interval.LAST_MONTH:
      dateFrom.setUTCMonth(dateFrom.getUTCMonth() - 1, 1);
      dateTo.setUTCMonth(dateTo.getUTCMonth());
      dateTo.setUTCDate(0);
      break;
    case Interval.THIS_MONTH:
      dateFrom.setUTCDate(1);
      dateTo.setUTCMonth(dateTo.getUTCMonth() + 1, 1);
      dateTo.setUTCDate(0);
      break;
    case Interval.MIN_AND_MAX_DATES:
      dateFrom.setUTCFullYear(picked.getUTCFullYear(), picked.getUTCMonth(), picked.getUTCDate());
      dateTo.setUTCFullYear(
        dateFrom.getUTCFullYear(),
        dateFrom.getUTCMonth(),
        dateFrom.getUTCDate() + MAX_DATE_INTERVAL,
      );
      break;
    case Interval.PREV_PERIOD:
      dateFrom.setUTCDate(dateFrom.getUTCDate() - (dateFrom.getUTCDay() + 7));
      dateTo.setUTCFullYear(
        dateFrom.getUTCFullYear(),
        dateFrom.getUTCMonth(),
        dateFrom.getUTCDate() + daysInCurrentPeriod,
      );
      break;
    case Interval.CURRENT_PERIOD:
      dateFrom.setUTCDate(dateFrom.getUTCDate() - dateFrom.getUTCDay());
      dateTo.setUTCDate(dateTo.getUTCDate());
      break;
    case Interval.LAST_30_DAYS:
      dateFrom.setUTCDate(dateFrom.getUTCDate() - 30);
      dateTo.setUTCDate(dateTo.getUTCDate() - 1);
      break;
  }

  const fromYear = dateFrom.toLocaleString("en-US", { year: "numeric", timeZone: "UTC" });
  const fromMonth = dateFrom.toLocaleString("en-US", { month: "2-digit", timeZone: "UTC" });
  const fromDay = dateFrom.toLocaleString("en-US", { day: "2-digit", timeZone: "UTC" });
  const toYear = dateTo.toLocaleString("en-US", { year: "numeric", timeZone: "UTC" });
  const toMonth = dateTo.toLocaleString("en-US", { month: "2-digit", timeZone: "UTC" });
  const toDay = dateTo.toLocaleString("en-US", { day: "2-digit", timeZone: "UTC" });

  return {
    from: `${fromYear}-${fromMonth}-${fromDay}`,
    to: `${toYear}-${toMonth}-${toDay}`,
  };
};

export default getDateInterval;
